import { colors, sizes } from '@lmc/common/constants'
import { Button } from '@lmc/ui-kit'
import { isBrowser, isTablet } from 'react-device-detect'
import styled from 'styled-components'

const isDesktopLayout = isBrowser || isTablet

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const MainContainer = styled.div`
  margin: 0 auto;
  max-width: ${sizes.childScreen}px;
  padding: 20px 20px 100px 20px;
  flex: 1;
`

const QuoteBox = styled.div`
  margin-top: 24px;
`

const FormContainer = styled.div`
  margin-top: 25px;
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: ${isDesktopLayout ? 'calc(100vw - 290px)' : '100vw'};
`

const FinaliseButton = styled(Button)`
  background: ${colors.green};
  color: white;
  padding: 0 25px;
  text-shadow: none;
  margin-right: 20px;
`

export const Components = {
  Wrapper,
  MainContainer,
  QuoteBox,
  FormContainer,
  Footer,
  FinaliseButton
}
